import find from "lodash.find";
import { SCREENS } from "../../../common/constants/Constants";
import { BULK_SUBSCRIPTION_USER_ROLES } from "../../../common/constants/v2/Constants";

function isBulkAdmin(userId?: string, users: User[] = []): boolean {
    if (!userId) {
        return false;
    }

    return Boolean(find(users, (user: User): boolean => {
        return user.id === userId && user.role === BULK_SUBSCRIPTION_USER_ROLES.ADMIN;
    }));
}

function orderBulkSubscriptionUsers(userA: User, userB: User): number {
    const {
        lastName: lastNameA,
        firstName: firstNameA,
        email: emailA
    } = userA;
    const {
        lastName: lastNameB,
        firstName: firstNameB,
        email: emailB
    } = userB;

    if (lastNameA && lastNameB) {
        return lastNameA.localeCompare(lastNameB);
    }

    if (lastNameA && !lastNameB) {
        return -1;
    }

    if (!lastNameA && lastNameB) {
        return 1;
    }

    if (firstNameA && firstNameB) {
        return firstNameA.localeCompare(firstNameB);
    }

    if (firstNameA && !firstNameB) {
        return -1;
    }

    if (!firstNameA && firstNameB) {
        return 1;
    }

    if (emailA && emailB) {
        return emailA.localeCompare(emailB);
    }

    if (emailA && !emailB) {
        return -1;
    }

    if (!emailA && emailB) {
        return 1;
    }

    return 0;
}

function countAdmins(users: User[] = []): number {
    return users.filter((user) => {
        return user.role === BULK_SUBSCRIPTION_USER_ROLES.ADMIN;
    }).length;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function hasBulkSubsRedirectTo({ redirectTo }: {redirectTo?: string; [s: string]: any} = {}): boolean {
    return new RegExp(SCREENS.BULK_SUBSCRIPTION_PURCHASE_FORM).test(redirectTo || "");
}

export {
    isBulkAdmin,
    orderBulkSubscriptionUsers,
    hasBulkSubsRedirectTo,
    countAdmins
};
